/* eslint-env browser */
import { frontendURL } from '../../../helper/URLHelper';

const BotHub = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/bot-hub'),
    name: 'bot_hub_dashboard_index',
    meta: {
      permissions: ['administrator'],
    },
    component: BotHub,
  },
];
